<template>
  <b-modal
    :id="modalId"
    :visible="visible"
    :title="title"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    ok-variant="success"
    cancel-variant="outline-secondary"
    ok-only
    @ok="handleOk"
    @cancel="handleCancel"
    @hidden="handleCancel">
    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="success"
        @click="ok()">
        {{ okTitle }}
      </b-button>
      <b-button
        variant="outline-secondary"
        @click="cancel()">
        {{ cancelTitle }}
      </b-button>
    </template>
    <p class="mb-3">{{ message }}</p>

    <!-- Justificativa (Opcional para confirmação) -->
    <b-form-group
      :label="justificationLabel"
      :label-for="`${modalId}-justification`">
      <b-form-textarea
        :id="`${modalId}-justification`"
        v-model="localJustification"
        rows="3"
        :placeholder="justificationPlaceholder"
        :state="validationState"></b-form-textarea>
      <b-form-invalid-feedback :state="validationState">
        {{ errorMessage }}
      </b-form-invalid-feedback>
    </b-form-group>
  </b-modal>
</template>

<script>
import { BModal, BButton, BFormGroup, BFormTextarea, BFormInvalidFeedback } from 'bootstrap-vue'

export default {
  name: 'ConfirmModal',
  components: {
    BModal,
    BButton,
    BFormGroup,
    BFormTextarea,
    BFormInvalidFeedback
  },
  props: {
    modalId: {
      type: String,
      default: 'confirm-modal'
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    justificationLabel: {
      type: String,
      default: 'Observações (Opcional)'
    },
    justificationPlaceholder: {
      type: String,
      default: 'Adicione observações sobre a conclusão (opcional)...'
    },
    okTitle: {
      type: String,
      default: 'Confirmar Conclusão'
    },
    cancelTitle: {
      type: String,
      default: 'Voltar'
    },
    errorMessage: {
      type: String,
      default: 'Erro ao processar'
    },
    requireJustification: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localJustification: '',
      validationState: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    handleOk(bvModalEvent) {
      // Previne o fechamento automático do modal
      bvModalEvent.preventDefault()

      // Valida se a justificativa é obrigatória
      if (this.requireJustification && (!this.localJustification || this.localJustification.trim() === '')) {
        this.validationState = false
        return
      }

      this.validationState = true

      // Emite o evento de confirmação com os dados
      const data = {
        justification: this.localJustification ? this.localJustification.trim() : null
      }

      this.$emit('confirm', data)

      // Fecha o modal
      this.$nextTick(() => {
        this.$bvModal.hide(this.modalId)
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },
    resetForm() {
      this.localJustification = ''
      this.validationState = null
    }
  }
}
</script>

<style scoped>
/* Adicione estilos personalizados se necessário */
</style>

